module.exports = __webpack_public_path__ + "img/sebastian-hagens-1.06f3f8ab.jpg";